@import "~@uipath/apollo-core/src/scss/base-host.scss";

.header {
    margin: 24px 24px 12px 24px;
    display: flex;
    align-items: center;
    font-weight: $font-weight-bold;
    font-size: 20px;
    font-family: $font-normal;
    line-height: 24px;
    column-gap: 20px;
    color: var(--color-foreground);
}

.body {
    margin-left: 24px;
    margin-right: 24px;

    p {
        color: var(--color-foreground);
        line-height: 22px;
        font-family: $font-normal;
        margin: 0;
    }
}

.footer {
    margin: 28px 24px 24px 24px;
    display: flex;
    justify-content: flex-end;
    column-gap: 8px;
}
